import { SET_INCOMING_URL } from '../actions';

const initialState = {
    incomingUrl: ''
}

export const routesReducer = (state=initialState, action) => {
    const {type, payload} = action;
    if(type === SET_INCOMING_URL){
       const {url} = payload;
       return {
           ...state,
           incomingUrl:url
       }
    }
    return state;
}

